import type { Cave } from "../api";

// The cave URL slug (admin redesign, Phase 2). Use the host's first DNS label
// (cave2.beta.legendsportscave.com → "cave2"): it is unique and stable in DNS,
// unlike the display name — two caves are called "Curt Schilling" and
// "CurtSchilling" today and slugifying the name would collide. Falls back to the
// cave id when a cave has no host (shouldn't happen for a provisioned cave).
export function caveSlug(cave: Pick<Cave, "host" | "id">): string {
  const label = (cave.host ?? "").split(".")[0].trim();
  return label || cave.id;
}

export function caveBySlug<T extends Pick<Cave, "host" | "id">>(
  caves: T[],
  slug: string,
): T | undefined {
  return caves.find((c) => caveSlug(c) === slug);
}
